import {
    Avatar,
    Box,
    IconButton,
    Menu,
    MenuItem,
    Popover,
    Stack,
    Typography,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CircleIcon from '@mui/icons-material/Circle';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CheckIcon from '@mui/icons-material/Check';
import ReactTimeAgo from 'react-time-ago';
import React, { useEffect } from 'react';
import {
    getNotifications,
    readAllNotification,
    readNotificationById,
} from 'services/notification.service';
import { createStyleSheet, handleError } from 'utils/helpers';
import { INotificationResponse } from 'types/notification';
import dayjs from 'dayjs';
interface IProps {
    idPopover: string;
    openPopover: boolean;
    anchorElNotification: HTMLButtonElement | null;
    handleCloseNotification: () => void;
}
const Notification: React.FC<IProps> = ({
    idPopover,
    openPopover,
    anchorElNotification,
    handleCloseNotification,
}) => {
    const [notifications, setNotifications] =
        React.useState<INotificationResponse>();
    const [page, setPage] = React.useState(1);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [expandScreen, setExpandScreen] = React.useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getNotifications({ page, per_page: 10 });
                if (response.success) {
                    setNotifications((prev) => ({
                        page: response.data.page || 1,
                        per_page: response.data.per_page || 10,
                        total_items: response.data.total_items || 0,
                        total_page: response.data.total_page || 0,
                        notifications: [
                            ...(prev?.notifications || []),
                            ...response.data.notifications,
                        ],
                    }));
                }
            } catch (error) {
                handleError(error);
            }
        };
        fetchData();
    }, [openPopover, page]);
    const handleReadNotificationById = async (id: string) => {
        try {
            const response = await readNotificationById(id);
            if (response.success) {
                const newListNotification = [
                    ...(notifications?.notifications || []),
                ].map((item) =>
                    item.id === id
                        ? {
                              ...item,
                              attributes: {
                                  ...item.attributes,
                                  is_read: true,
                              },
                          }
                        : item
                );

                setNotifications((prev) => ({
                    page: prev?.page ?? 1,
                    per_page: prev?.per_page ?? 10,
                    total_items: prev?.total_items ?? 0,
                    total_page: prev?.total_page ?? 0,
                    notifications: newListNotification,
                }));
            }
        } catch (error) {
            handleError(error);
        }
    };

    const handleReadAllNotification = async () => {
        try {
            const response = await readAllNotification();
            if (response.success) {
                if (response.success) {
                    const newListNotification = [
                        ...(notifications?.notifications || []),
                    ].map((item) => ({
                        ...item,
                        attributes: {
                            ...item.attributes,
                            is_read: true,
                        },
                    }));

                    setNotifications((prev) => ({
                        page: prev?.page ?? 1,
                        per_page: prev?.per_page ?? 10,
                        total_items: prev?.total_items ?? 0,
                        total_page: prev?.total_page ?? 0,
                        notifications: newListNotification,
                    }));
                }
            }
        } catch (error) {
            handleError(error);
        }
    };

    return (
        <Popover
            id={idPopover}
            open={openPopover}
            anchorEl={anchorElNotification}
            onClose={handleCloseNotification}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            sx={{
                '& .MuiPaper-root.MuiPopover-paper': {
                    maxWidth: !expandScreen ? '600px' : '1000px',
                    maxHeight: `min(700px, calc(100% - ${104}px))`,
                    top: `${104}px !important`,
                    borderRadius: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            <Box
                sx={{
                    p: 2,
                    borderBottom: '1px solid #eee',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '18px',
                        }}
                        variant="subtitle1"
                    >
                        Thông báo
                    </Typography>
                    <IconButton
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                    >
                        <MoreHorizIcon
                            sx={{
                                cursor: 'pointer',
                                color: '#000000',
                                fontSize: '24px !important',
                            }}
                        />
                    </IconButton>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem
                            onClick={() => {
                                handleClose();
                                handleReadAllNotification();
                            }}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <CheckIcon /> Đánh dấu là đã đọc
                        </MenuItem>
                        <MenuItem
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                            onClick={() => {
                                handleClose();
                                setExpandScreen(!expandScreen);
                            }}
                        >
                            {expandScreen ? (
                                <CloseFullscreenIcon />
                            ) : (
                                <OpenInFullIcon />
                            )}
                            Mở rộng toàn màn hình
                        </MenuItem>
                    </Menu>
                </Stack>
            </Box>
            <Stack spacing={2} p={2}>
                {notifications?.notifications.length === 0 && (
                    <Typography align="center" sx={{ fontStyle: 'italic' }}>
                        Không có dữ liệu
                    </Typography>
                )}
                {notifications?.notifications?.map((item) => (
                    <Box
                        onClick={() => handleReadNotificationById(item.id)}
                        key={item.id}
                        display="flex"
                        alignItems="center"
                        justifyContent={'space-between'}
                        p={1}
                        mb={1}
                        sx={{
                            cursor: 'pointer',
                        }}
                    >
                        <Stack alignItems={'center'} flexDirection={'row'}>
                            <Avatar
                                sx={{
                                    width: '56px',
                                    height: '56px',
                                }}
                                src={item.attributes.avatar}
                                alt={`Avatar of ${item.attributes.avatar}`}
                            />
                            <Box ml={2}>
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                >
                                    <Box
                                        sx={styles.notification.content}
                                        component={'div'}
                                        dangerouslySetInnerHTML={{
                                            __html: item.attributes.content,
                                        }}
                                    />
                                </Stack>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                    sx={{
                                        color: (theme) =>
                                            theme.palette.primary.main,
                                    }}
                                >
                                    <ReactTimeAgo
                                        date={dayjs(
                                            item.attributes.created_at
                                        ).valueOf()}
                                    />
                                </Typography>
                            </Box>
                        </Stack>
                        {!item.attributes.is_read && (
                            <CircleIcon
                                sx={{
                                    color: 'primary.main',
                                    fontSize: '16px',
                                    alignSelf: 'self-start',
                                }}
                            />
                        )}
                    </Box>
                ))}
            </Stack>
            {(notifications?.total_page ?? 0) > page && (
                <Typography
                    onClick={() => {
                        setPage((prev) => prev + 1);
                    }}
                    sx={{
                        color: (theme) => theme.palette.primary.main,
                        cursor: 'pointer',
                        textAlign: 'center',
                        mt: 1,
                        mb: 2,
                    }}
                >
                    Xem thêm
                </Typography>
            )}
        </Popover>
    );
};
const styles = createStyleSheet({
    notification: {
        content: {
            '& p': {
                margin: 0,
                fontSize: '18px !important',
            },
        },
    },
});
export default Notification;
